import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { metricsTrack } from '../../utilities/analytics/index.js';
import '../../atoms/buttons/enums.js';
import { setDataAttributes, isRTL } from '../../utilities/dom-helpers/index.js';
import { setLineClamp } from '../../utilities/text-helpers/index.js';
import { imgLazyLoadingResolver } from '../../../common/img-lazy-loading-resolver.js';
import css_248z from './file-download-item.scss.js';
import { renderDownloadItemWithThumbnail, renderDownloadItem } from './layout/index.js';

class FileDownloadItem extends s {
    constructor() {
        super(...arguments);
        this.filePath = '';
        this.thumbnail = null;
        this.thumbnailAltText = '';
        this.headingSlot = null;
        this.addHoveredState = () => {
            var _a, _b, _c, _d;
            const iconButton = this.item
                .querySelector('slot.download')
                .assignedElements()[0];
            iconButton.setAttribute('styleType', 'dark');
            (_b = (_a = iconButton === null || iconButton === void 0 ? void 0 : iconButton.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('button')) === null || _b === void 0 ? void 0 : _b.classList.remove('style-outlined-dark');
            (_d = (_c = iconButton === null || iconButton === void 0 ? void 0 : iconButton.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector('button')) === null || _d === void 0 ? void 0 : _d.classList.add('style-dark');
        };
        this.removeHoveredState = () => {
            var _a, _b, _c, _d;
            const iconButton = this.item
                .querySelector('slot.download')
                .assignedElements()[0];
            iconButton.setAttribute('styleType', 'outlined-dark');
            (_b = (_a = iconButton === null || iconButton === void 0 ? void 0 : iconButton.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('button')) === null || _b === void 0 ? void 0 : _b.classList.remove('style-dark');
            (_d = (_c = iconButton === null || iconButton === void 0 ? void 0 : iconButton.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector('button')) === null || _d === void 0 ? void 0 : _d.classList.add('style-outlined-dark');
        };
        // eslint-disable-next-line class-methods-use-this
        this.handleClick = (e) => {
            const target = e.currentTarget;
            metricsTrack('cevt_click_download', {
                dlv_event_category: 'link',
                dlv_event_action: 'download',
                dlv_link_element: target,
                dlv_link_classes: target.getAttribute('class'),
                dlv_link_text: target.textContent,
                dlv_link_url: target.href,
            });
        };
    }
    firstUpdated() {
        this.item = this.shadowRoot.querySelector('.file-download-item');
        this.item.addEventListener('mouseenter', this.addHoveredState);
        this.item.addEventListener('mouseleave', this.removeHoveredState);
        setDataAttributes(this, 'file-name', null);
        setLineClamp(this, 80, null);
        imgLazyLoadingResolver(this.renderRoot);
        if (this.rtl || isRTL()) {
            // fix rtl language filename placeholder order
            this.querySelector('generic-button span').style.direction =
                'initial';
        }
    }
    render() {
        return this.thumbnail
            ? renderDownloadItemWithThumbnail(this)
            : renderDownloadItem();
    }
}
FileDownloadItem.styles = css_248z;
__decorate([
    n({ type: Boolean })
], FileDownloadItem.prototype, "rtl", void 0);
__decorate([
    n({ type: String })
], FileDownloadItem.prototype, "filePath", void 0);
__decorate([
    n({ type: String })
], FileDownloadItem.prototype, "thumbnail", void 0);
__decorate([
    n({ type: String })
], FileDownloadItem.prototype, "thumbnailAltText", void 0);
__decorate([
    t()
], FileDownloadItem.prototype, "item", void 0);
__decorate([
    t()
], FileDownloadItem.prototype, "headingSlot", void 0);
customElements.define('file-download-item', FileDownloadItem);

export { FileDownloadItem };
